import { Wrench, ListChecks } from 'lucide-react';
import { Puce, Section, Tableau } from './constantes';
import { CoursReseaux } from './CoursReseaux';

const Gantt = ({ o, teinte }) => {
  const n = o.mois.reduce((t, [, k]) => t + k, 0);
  const grille = { gridTemplateColumns: `minmax(140px, 3fr) repeat(${n}, minmax(0, 1fr))` };
  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200" data-testid="guide-gantt">
      <div className="min-w-[640px] text-sm">
        <div className="grid bg-[#0F172A] text-xs font-semibold text-white" style={grille}>
          <span className="px-3 py-2.5">Étape</span>
          {o.mois.map(([m, k]) => <span key={m} className="border-l border-white/10 py-2.5 text-center" style={{ gridColumn: `span ${k}` }}>{m}</span>)}
        </div>
        {o.taches.map(([t, d, f]) => (
          <div key={t} className="grid border-t border-slate-100 odd:bg-white even:bg-slate-50" style={grille}>
            <span className="px-3 py-2 text-slate-700">{t}</span>
            <span className="relative" style={{ gridColumn: `span ${n}` }}>
              <span className={`absolute top-1/2 h-4 -translate-y-1/2 rounded-full ${teinte.fort}`} style={{ left: `${(100 * d) / n}%`, width: `${(100 * (f - d + 1)) / n}%` }} />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export const OutilsBloc = ({ bloc, teinte }) => (
  <Section titre={`Outils complémentaires du ${bloc.code}`} sousTitre="À réutiliser et à adapter dans votre dossier." testId={`guide-outils-${bloc.code}`}>
    <div className="space-y-6">
      {bloc.outils.map((o) => (
        <div key={o.titre}>
          <h3 className={`mb-3 flex items-center gap-2 text-sm font-bold ${teinte.texte}`}><Wrench className="h-4 w-4" /> {o.titre}</h3>
          {o.type === 'gantt' && <Gantt o={o} teinte={teinte} />}
          {o.type === 'cours' && <CoursReseaux o={o} teinte={teinte} />}
          {o.colonnes && <Tableau o={o} teinte={teinte} />}
          {o.liste && <ul className="space-y-1.5">{o.liste.map((x) => <Puce key={x}>{x}</Puce>)}</ul>}
          {o.note && <p className="mt-2 text-xs italic text-slate-500">{o.note}</p>}
        </div>
      ))}
    </div>
  </Section>
);

export const ChecklistBloc = ({ bloc, teinte, progression }) => {
  const coches = progression.etat.check[bloc.code] || [];
  return (
    <Section titre={`Checklist du ${bloc.code}`} sousTitre={`Documents à rassembler avant de rédiger · ${coches.length}/${bloc.checklist.length} prêts`} testId={`guide-checklist-${bloc.code}`}>
      <ul className="grid gap-2 sm:grid-cols-2">
        {bloc.checklist.map((x, k) => (
          <li key={x}>
            <label className={`flex cursor-pointer items-start gap-3 rounded-xl border p-3 text-sm transition-colors ${coches.includes(k) ? `${teinte.clair} border-transparent` : 'border-slate-200 hover:bg-slate-50'}`} data-testid={`guide-check-${bloc.code}-${k}`}>
              <input type="checkbox" checked={coches.includes(k)} disabled={progression.lecture} onChange={() => progression.basculerCheck(bloc.code, k)} className="mt-0.5 h-4 w-4 accent-emerald-600" />
              <span className="text-slate-700">{x}</span>
            </label>
          </li>
        ))}
      </ul>
      <p className="mt-4 flex items-center gap-2 text-xs text-slate-400"><ListChecks className="h-4 w-4" /> Pensez à anonymiser tous les documents avant de les mettre en annexe.</p>
    </Section>
  );
};
